import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { Button } from './Button';
export function Footer() {
  return <footer className="w-full bg-black text-white py-16 px-4" data-id="element-75">
      <div className="max-w-7xl mx-auto" data-id="element-76">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr] gap-12" data-id="element-77">
          {/* Brand Column */}
          <div data-id="element-78">
            <Link to="/" className="inline-block mb-6" data-id="element-79">
              <img src="https://cdn.magicpatterns.com/uploads/ghb8oGu2AFpSGCwhCKzLpD/White_logo.png" alt="EquityRich" className="h-10 w-auto" data-id="element-80" />
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-81">
              EquityRich.ca is a Canadian entity, operating as a referral
              institution. Mortgage Agents and Brokers represent Everything
              Mortgages (FSRA #12755)
            </p>
            <Button variant="primary" size="md" href="/#form" data-id="element-82">
              Find Out How Much You Can Borrow
            </Button>
          </div>

          {/* Services Column */}
          <div data-id="element-83">
            <h3 className="text-lg mb-6 font-[500]" data-id="element-84">SERVICES</h3>
            <ul className="space-y-3" role="list" data-id="element-85">
              <li data-id="element-86">
                <Link to="/services/home-equity-loans" className="text-gray-400 hover:text-accent transition-colors" data-id="element-87">
                  First Mortgages
                </Link>
              </li>
              <li data-id="element-88">
                <Link to="/services/second-mortgages" className="text-gray-400 hover:text-accent transition-colors" data-id="element-89">
                  Second Mortgages
                </Link>
              </li>
              <li data-id="element-90">
                <Link to="/services/heloc" className="text-gray-400 hover:text-accent transition-colors" data-id="element-91">
                  Equity Lending
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/services" className="text-gray-400 hover:text-accent transition-colors" data-id="element-93">
                  Debt Consolidation
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links Column */}

          {/* Locations Column */}
          <div data-id="element-94">
            <h3 className="text-lg mb-6 font-[500]" data-id="element-95">LOCATIONS</h3>
            <ul className="space-y-3" role="list" data-id="element-96">
              <li data-id="element-97">
                <Link to="/locations/toronto" className="text-gray-400 hover:text-accent transition-colors" data-id="element-98">
                  Toronto
                </Link>
              </li>
              <li data-id="element-99">
                <Link to="/locations/mississauga" className="text-gray-400 hover:text-accent transition-colors" data-id="element-100">
                  Mississauga
                </Link>
              </li>
              <li data-id="element-101">
                <Link to="/locations/brampton" className="text-gray-400 hover:text-accent transition-colors" data-id="element-102">
                  Brampton
                </Link>
              </li>
              <li data-id="element-103">
                <Link to="/locations/markham" className="text-gray-400 hover:text-accent transition-colors" data-id="element-104">
                  Markham
                </Link>
              </li>
              <li data-id="element-105">
                <Link to="/locations/vaughan" className="text-gray-400 hover:text-accent transition-colors" data-id="element-106">
                  Vaughan
                </Link>
              </li>
              <li data-id="element-107">
                <Link to="/locations/richmond-hill" className="text-gray-400 hover:text-accent transition-colors" data-id="element-108">
                  Richmond Hill
                </Link>
              </li>
              <li data-id="element-109">
                <Link to="/locations/oakville" className="text-gray-400 hover:text-accent transition-colors" data-id="element-110">
                  Oakville
                </Link>
              </li>
              <li data-id="element-111">
                <Link to="/locations/burlington" className="text-gray-400 hover:text-accent transition-colors" data-id="element-112">
                  Burlington
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div data-id="element-113">
            <h3 className="text-lg mb-6 font-[500]" data-id="element-114">CONTACT</h3>
            <ul className="space-y-4" role="list" data-id="element-115">
              <li className="flex items-start" data-id="element-116">
                <PhoneIcon className="h-5 w-5 mr-3 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-117" />
                <div data-id="element-118">
                  <p className="text-sm font-medium mb-1" data-id="element-119">Phone</p>
                  <a href="tel:+16476679957" className="text-gray-400 hover:text-accent transition-colors" data-id="element-120">
                    +1-647-667-9957
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-121">
                <MailIcon className="h-5 w-5 mr-3 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-122" />
                <div data-id="element-123">
                  <p className="text-sm font-medium mb-1" data-id="element-124">Email</p>
                  <a href="mailto:info@equityrich.ca" className="text-gray-400 hover:text-accent transition-colors" data-id="element-125">
                    info@equityrich.ca
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-126">
                <MapPinIcon className="h-5 w-5 mr-3 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-127" />
                <div data-id="element-128">
                  <p className="text-sm font-medium mb-1" data-id="element-129">Office</p>
                  <p className="text-gray-400" data-id="element-130">
                    18 Wynford Dr, Suite 307,
                    <br data-id="element-131" />
                    Toronto, ON, M3C 3S2
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center" data-id="element-132">
          <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-133">
            Copyright © 2026 Equity Rich. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-134">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors" aria-label="Facebook" data-id="element-135">
              <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" aria-hidden="true" data-id="element-136">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-137" />
              </svg>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors" aria-label="X (Twitter)" data-id="element-138">
              <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" aria-hidden="true" data-id="element-139">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-140" />
              </svg>
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors" aria-label="YouTube" data-id="element-141">
              <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" aria-hidden="true" data-id="element-142">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-143" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}